/**
 * @author sunzhiguang
 * @date 2020/7/10
 */
import React, { useCallback, useEffect, useMemo, useState, useRef, useContext } from "react";
import {
  AI_CHAT_PREDICT,
  ChatMessage,
  ChatMessageRespBody,
  ClientType,
  FileStatus,
  MessageStatus,
  SessionType
} from "@/types/chat";
import ImService from "@/server/ImService";
import { MessageSendType } from "@/types/chat/enum";
import { Loading3QuartersOutlined } from "@/utils/antdIcon";

import { Spin, Tooltip, message as toast } from "antd";
import IconFont from "@/components/icon";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import cloneDeep from "lodash/cloneDeep";
import "./index.less";
import { connect } from "dva";
import ChatState from "@/types/chat/State";

import config, { ChatConfig, ConfigEnum } from "@/config/config";
import EventBus from "@/utils/bus";
import Prompt from "@/baseComponents/ModalComponent/prompt";
import omit from "lodash/omit";
import {
  isEqualEmployee,
  isOuterContacts,
  isRevokeMessage,
  sleep,
  checkMeetingSysMessage,
  isReadMessage,
  isGroupAIReply,
  buildReplyEmojiMessageBody,
  sendReplyEmojiMessage,
  getQuickItem,
  convertEmployeeToString,
  buildMessageDetect,
  mapMessageDetectRes,
  buildAIChatMessageComm,
  showIntentTail,
  getFileDownloadBzType,
  getFileDownloadBzId
} from "@/utils/chat/message";
import ConnectState from "@jd/jdee.im.sdk/lib/es/enum/ConnectState";
import { ChatMessageType } from "@jd/jdee.im.sdk/lib/es/protocol/message/Type";
import { debounce } from "lodash";
import { changeGovUrl } from "@/utils/tools";
import {
  getAIChatSessionId,
  isAIChatNoticeSessionId,
  isAIChatSession,
  isAINoticeChildSession
} from "@/utils/chat/session";
import { nyrssfENStr } from "@/utils/date";
import { dataURLtoFile, dealImagesData } from "../../utils/image";
import { getFileMd5 } from "@/components/UploadBox/utils";
import { createUploadTask } from "@/server/FileService";
import log from "@/utils/logger";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import {
  convertUidToString,
  isLiveMeetingSessionId,
  isMeetingSessionId
} from "@jd/jdee.im.sdk/lib/es/utils/utils";
import ChatContext from "@/components/chat/context";
import { getClientType } from "@/utils";
import { MessageExtAction } from "@jd/jdee.im.sdk/lib/es/protocol/messageExtend/Type";
import MessageDongReadStatusBtn from "../Item/MessageDongReadStatusBtn";

interface MessageControlProps {
  sendType: MessageSendType;
  sessionType: SessionType;
  message: ChatMessage & ChatMessageRespBody;
  beginSend: boolean;
  messageExtend: any;
  onSendStatus: Function;
  statusType?: MessageStatus;
  questionHistory?: any[];
  administrator: any;
  sub_administrator: any;
  quickReplys: any[];
}

interface DvaDispatchProps {
  updateSessionMessageMid: Function;
  clearMessageUploadState: Function;
  clearTempMessage: Function;
  updateTempMessageStatus: Function;
  updateQuestionHistory: Function;
  updateMessageUploadState: Function;
  deleteSessionMessages: Function;
}

type IProps = Readonly<MessageControlProps & DvaDispatchProps & ChatState>;

interface IState {
  status: MessageStatus;
}

const MessageControl = (props: IProps) => {
  const [status, setStatus] = useState(MessageStatus.INIT);
  const { t } = useTranslation("chat");
  const antIcon = <Loading3QuartersOutlined style={{ fontSize: 14 }} spin />;
  const mountedRef = useRef(false);
  const curRef = useRef(0);
  const {
    sessionType,
    sendType,
    message,
    beginSend,
    messageExtend,
    updateSessionMessageMid,
    onSendStatus,
    clearMessageUploadState,
    clearTempMessage,
    messageUploadStateMap,
    currentEmployee,
    selectedSession,
    connectState,
    updateTempMessageStatus,
    updateMessageUploadState,
    statusType,
    questionHistory,
    updateQuestionHistory,
    sessionMessageMap,
    deleteSessionMessages,
    tempSessionMessageMap,
    quickReplys,
    administrator,
    sub_administrator,
    currentAIRobot
  } = props;

  const messageUploadState = useMemo(() => {
    return messageUploadStateMap[message.id] || null;
  }, [message, messageUploadStateMap]);

  const getReadInfo = (isRead: boolean) => {
    // const isRead = isReadMessage(message, currentEmployee);
    return {
      iconType: !isRead ? "iconapp_btn_radio_normal" : "iconic_complete_2",
      text: !isRead ? t("unRead") : t("read")
    };
  };

  const FileInfoMap = new Map<string, {}>();
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const { isLLMAI, quickReplyConfig } = useContext(ChatContext);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (statusType) {
      setStatus(statusType);
    } else if (message.status && connectState.state !== ConnectState.READY) {
      if (message.task && message.task.state !== FileStatus.COMPLETED) {
        message.task.cancel();
        setStatus(MessageStatus.FAILED);
      }
    } else if (message.statusType === MessageStatus.FAILED) {
      setStatus(MessageStatus.FAILED);
    }
  }, [message, connectState, statusType]);

  const readStatusEnable = config[ChatConfig.CHAT_MESSAGE_STATUS_READ_UNREAD_ENABLE];
  const canSearchUser = config[ConfigEnum.EXTERNAL_CONTACTS_ADD_CONTACTS];
  const getMessageState = () => {
    // eslint-disable-next-line no-console
    if (!readStatusEnable) {
      return null;
    }
    if (isRevokeMessage(message)) {
      return null;
    }
    // if (selectedSession.isSingle) {
    //     const info = selectedSession.info as Employee;
    //     if (info.app !== currentEmployee.app) {
    //         return null;
    //     }
    // }
    // 外部联系人 去掉已读未读状态
    // if (isOuterContacts(selectedSession, currentEmployee)) {
    //   return null;
    // }
    if (sendType !== MessageSendType.SELF && sendType === MessageSendType.OWNER) {
      const isSys = checkMeetingSysMessage({ message });
      const lastMsg = selectedSession.lastMsg || {};
      const isRead = isReadMessage(message, currentEmployee, lastMsg);
      // eslint-disable-next-line no-console
      const { iconType, text } = getReadInfo(isRead);
      const getClassNames = () => {
        return classNames({
          "status-icon": true,
          "read-icon": isRead,
          "unread-icon": !isRead
        });
      };
      return isSys || message.mid <= 0 ? null : (
        <div className="message-status">
          {isRead &&
            <Tooltip className="custom-status-icon" overlayStyle={{fontSize: "12px"}} placement="top" title="已读">
              <IconFont type="iconFrame2" />
            </Tooltip>
          }
          {!isRead &&
            <Tooltip className="custom-status-icon" overlayStyle={{fontSize: "12px"}} placement="top" title="未读">
              <IconFont type="iconFrame-11" />
            </Tooltip>
          }
          {/* <IconFont className={getClassNames()} type={iconType} /> */}
          {/* <div className="word read">{text}</div> */}
        </div>
      );
    }
  };
  const getGroupMessageReadState = () => {
    return (<div className="group-read-status">
      {isEqualEmployee(message.sender, currentEmployee) &&
        selectedSession.isGroup &&
        (selectedSession.info as any).msgDongRead === 1 && (
          <MessageDongReadStatusBtn message={message} />
        )}
    </div>)
  }
  const clearMessage = useCallback(() => {
    if (message.type === ChatMessageType.FILE) {
      // 如果是文件的消息 需要消掉上传时的辅助数据
      delete message.taskId;
      delete message.task;
    }
    clearTempMessage({ msgId: message.id, sessionId: message.sessionId });
    // clearMessageUploadState({ msgId: message.id });
  }, [message, clearTempMessage]);

  useEffect(() => {
    if (status !== MessageStatus.INIT) {
      onSendStatus(status);
    }
  }, [status, onSendStatus]);

  const deleteAttr = useCallback((message: any) => {
    delete message.status;
    delete message.statusType;
    if (message.task) {
      // delete message.taskId;
      // delete message.task;
    }
  }, []);

  const handleSendReplyEmoji = useCallback(
    async (message: any, item: any) => {
      if (!message || !item) {
        return;
      }
      const msgContentItem = {
        text: item.detail,
        emojiCode: item.id,
        users: [
          {
            pin: currentEmployee.userId,
            app: currentEmployee.app,
            teamId: currentEmployee.teamId,
            clientType: getClientType() === "MAC" ? ClientType.MAC : ClientType.PC,
            timeStamp: new Date().getTime()
          }
        ]
      };
      sendReplyEmojiMessage({
        action: MessageExtAction.ADD,
        session: selectedSession,
        message,
        msgContentItem
      });
    },
    [currentEmployee, selectedSession]
  );

  const doHandleQuickReply = useCallback(
    async (msg: any) => {
      const imService = ImService.getInstance();
      // 1. 获取最后一条可回复消息
      const uids = [...administrator, ...sub_administrator]
        .filter((item) => {
          return convertUidToString(item?.user) !== convertEmployeeToString(currentEmployee);
        })
        .map((item) => {
          return convertUidToString(item?.user);
        });
      const searchKeys: string[] = quickReplyConfig?.keyword || [];
      const sessionId = selectedSession.sessionId;
      const msgs = await imService?.search({
        sessionId,
        searchKey: "",
        searchKeys,
        fromUids: uids,
        limit: 1,
        startMid: msg.mid,
        searchType: ChatMessageType.TEXT
      });
      // 2. 发送ext
      if (!msgs?.length) {
        return;
      }
      await handleSendReplyEmoji(msgs[0], getQuickItem(quickReplys, msg.content));
      // 3. 隐藏原始消息
      await sleep(2000);
      const result = await imService.deleteMessage({
        sessionId: selectedSession.sessionId,
        ...msg
      });
      if (result) {
        deleteSessionMessages({ message: msg });
      }
    },
    [
      administrator,
      sub_administrator,
      quickReplyConfig?.keyword,
      selectedSession.sessionId,
      handleSendReplyEmoji,
      quickReplys,
      deleteSessionMessages
    ]
  );

  const sendMessage = useCallback(async () => {
    // if (connectState.state !== ConnectState.READY) {
    //     setStatus(MessageStatus.FAILED);
    //     updateTempMessageStatus({
    //         status: MessageStatus.FAILED,
    //         id: message.id,
    //         sessionId: selectedSession.sessionId,
    //     });
    //     return;
    // }
    // 删除不需要的属性
    deleteAttr(message);
    const messageId = message.id;
    const sessionId = message.sessionId;
    const messageBody = omit(cloneDeep(message), [
      "status",
      "taskId",
      "task",
      "mid",
      "beforeMid",
      "sessionId",
      "groupId",
      "statusType",
      "_id",
      "_rev",
      "belong",
      "datetime",
      "mid",
      "localSendTimestamp",
      "readNum",
      "readUids"
    ]) as any;

    if (messageBody.type === ChatMessageType.FILE) {
      delete messageBody.id;
    }
    if (messageExtend) {
      Object.assign(messageBody, messageExtend);
    }
    const imService = ImService.getInstance();
    let { url, webUrl } = messageBody;
    if (url) {
      messageBody.url = changeGovUrl(messageBody.url);
    }
    if (webUrl) {
      messageBody.webUrl = changeGovUrl(messageBody.webUrl);
      messageBody.content = changeGovUrl(messageBody.content);
    }
    // 如果是包含图片的富文本消息，需要等图片上传完后发出消息
    if (message.type === ChatMessageType.TEXT && message?.quillImage?.length) {
      let quillJson: any[] = [];
      let imageCount = 0;
      let imageUrl: any = [];
      let urlToFile;
      let fileData;
      const imService = ImService.getInstance();
      const quillText = messageBody.quillJson;
      const filterList = message.quillImage.filter((item: any) => {
        const reg = /^https?:\/\//;
        const isHttp = reg.test(item?.url || item);
        if (isHttp) {
          imageUrl.push(item?.url || item);
        }
        return !isHttp;
      });
      if (filterList?.length === 0) {
        messageBody.quillImage = imageUrl;
        imService.sendChatMessage(sessionId, messageId, messageBody).then((result) => {
          if (result?.mid && result.id === messageId) {
            if (mountedRef.current) {
              setStatus(MessageStatus.SUCCESS);
            }
            updateSessionMessageMid({
              sessionId: messageBody.sessionId,
              sendResult: result
            });
            clearMessage();
          } else {
            if (mountedRef.current) {
              setStatus(MessageStatus.SENDING);
            }
            updateTempMessageStatus({
              status: MessageStatus.FAILED,
              id: messageBody.id,
              sessionId: selectedSession.sessionId
            });
          }
        });
      } else {
        for (const [index, image] of filterList.entries()) {
          urlToFile = dataURLtoFile(image.url, image.title);
          fileData = await dealImagesData(urlToFile);
          const { imgState, file } = fileData;
          const fileMd5 = getFileMd5(file);
          const task: any = createUploadTask(sessionId, file, {
            appKey: appRuntimeEnv.fileService.imAppKey,
            bizType: getFileDownloadBzType(selectedSession),
            bizId: getFileDownloadBzId(selectedSession)
          });
          if (task) {
            task.on("state", async (state1: any) => {
              if (state1.state === FileStatus.FAILED) {
                setStatus(MessageStatus.FAILED);
                toast.error(state1?.reason?.message || "图片上传失败，请重试！");
                updateTempMessageStatus({
                  status: MessageStatus.FAILED,
                  id: messageBody.id,
                  sessionId: selectedSession.sessionId
                });
                return;
              }
              if (state1.state === "completed") {
                if (!state1.downloadUrl) return;
                FileInfoMap.set(index.toString(), {
                  url: state1.downloadUrl,
                  height: imgState.height,
                  size: imgState.size,
                  width: imgState.width,
                  title: image.title,
                  fileMd5: fileMd5
                });
                imageUrl.push(state1.downloadUrl);
                if (FileInfoMap.size === filterList.length) {
                  for (const item of quillText) {
                    const insert = item.insert;
                    const reg = /^https?:\/\//;
                    if (insert && insert?.image && !reg.test(insert.image.url)) {
                      quillJson.push({
                        insert: {
                          image: {
                            ...insert.image,
                            ...FileInfoMap.get(imageCount.toString())
                          }
                        }
                      });
                      imageCount++;
                    } else {
                      quillJson.push(item);
                    }
                  }
                  messageBody.quillJson = quillJson;
                  messageBody.quillImage = imageUrl;
                  imService.sendChatMessage(sessionId, messageId, messageBody).then((result) => {
                    if (result?.mid && result.id === messageId) {
                      if (mountedRef.current) {
                        setStatus(MessageStatus.SUCCESS);
                      }
                      updateSessionMessageMid({
                        sessionId: messageBody.sessionId,
                        sendResult: result
                      });
                      clearMessage();
                    } else {
                      if (mountedRef.current) {
                        setStatus(MessageStatus.SENDING);
                      }
                      updateTempMessageStatus({
                        status: MessageStatus.FAILED,
                        id: messageBody.id,
                        sessionId: selectedSession.sessionId
                      });
                    }
                  });
                }
              }
            });
            task?.start();
          } else {
            log.warn("创建上传任务失败=======>", JSON.stringify(file));
          }
        }
      }
      return;
    } else {
      // 上传
      if (message.type === ChatMessageType.FILE || message.type === ChatMessageType.EGOV_FILE) {
        const regex = /^(?!\s*$)([^?]+)(\?.*)?$/; // 判断url不为空，并且如果url中有问号，问号前面的部分也不为空
        if ((url && regex.test(url)) || (webUrl && regex.test(webUrl))) {
          imService.sendChatMessage(sessionId, messageId, messageBody).then((result) => {
            if (result?.mid && result.id === messageId) {
              // 探测
              // messageDetect(buildMessageDetect([result], selectedSession)).then((res) => {
              //   if (res) {
              //     const msgRes = mapMessageDetectRes(res, result);
              //     updateSessionMessageMid({
              //       sessionId,
              //       sendResult: {
              //         body: msgRes
              //       },
              //       saveLocal: true
              //     });
              //   }
              // });
              if (mountedRef.current) {
                setStatus(MessageStatus.SUCCESS);
              }
              updateSessionMessageMid({
                sessionId: messageBody.sessionId,
                sendResult: result
              });
              clearMessage();
            } else {
              if (mountedRef.current) {
                setStatus(MessageStatus.SENDING);
              }
              updateTempMessageStatus({
                status: MessageStatus.FAILED,
                id: messageBody.id,
                sessionId: selectedSession.sessionId
              });
            }
          });
        } else {
          updateMessageUploadState({
            msgId: messageId,
            progress: 100,
            uploadResult: { downloadUrl: "" }
          });
          setStatus(MessageStatus.SENDING);
          // setStatus(MessageStatus.FAILED);
        }
      } else {
        imService.sendChatMessage(sessionId, messageId, messageBody).then((result) => {
          if (
            result &&
            (result?.mid || isMeetingSessionId(sessionId) || isLiveMeetingSessionId(sessionId)) &&
            result.id === messageId
          ) {
            if (mountedRef.current) {
              setStatus(MessageStatus.SUCCESS);
            }
            updateSessionMessageMid({
              sessionId: messageBody.sessionId,
              sendResult: result
            });
            // 探测
            // messageDetect(buildMessageDetect([result], selectedSession)).then((res) => {
            //   if (res) {
            //     const msgRes = mapMessageDetectRes(res, result);
            //     updateSessionMessageMid({
            //       sessionId,
            //       sendResult: {
            //         body: msgRes
            //       },
            //       saveLocal: true
            //     });
            //   }
            // });
            clearMessage();
          } else {
            if (mountedRef.current) {
              setStatus(MessageStatus.SENDING);
            }
            updateTempMessageStatus({
              status: MessageStatus.FAILED,
              id: messageBody.id,
              sessionId: selectedSession.sessionId
            });
          }
        });
      }
    }
  }, [
    deleteAttr,
    message,
    messageExtend,
    updateSessionMessageMid,
    clearMessage,
    updateTempMessageStatus,
    selectedSession.sessionId,
    appRuntimeEnv?.fileService?.imAppKey,
    FileInfoMap,
    updateMessageUploadState
  ]);

  const sendLLMMessage = useCallback(async () => {
    const task = message.task;
    let messageBody = omit(cloneDeep(message), [
      "status",
      "taskId",
      "task",
      "mid",
      "beforeMid",
      "sessionId",
      "groupId",
      "statusType",
      "_id",
      "_rev",
      "belong",
      "datetime",
      "mid",
      "localSendTimestamp",
      "readNum",
      "readUids"
    ]) as any;
    const imService = ImService.getInstance();
    if (!questionHistory || questionHistory.length === 0) {
      messageBody.history = [];
    } else {
      messageBody.history = [...questionHistory.map((i) => i.data)];
    }
    // ext中追加添加联系人
    let newExt = {
      grantAddFriends: canSearchUser
    };
    if (messageBody?.ext) {
      const oldExt =
        typeof messageBody.ext === "string" ? JSON.parse(messageBody.ext) : messageBody.ext;
      newExt = {
        ...oldExt,
        ...newExt
      };
    }
    messageBody.ext = JSON.stringify(newExt);
    const messageId = message.id;
    let { url } = messageBody;
    if (message.type === ChatMessageType.FILE || message.type === ChatMessageType.EGOV_FILE) {
      const regex = /^(?!\s*$)([^?]+)(\?.*)?$/; // 判断url不为空，并且如果url中有问号，问号前面的部分也不为空
      if (!(url && regex.test(url))) {
        messageBody.url = task?.downloadUrl;
      }
      messageBody = await buildAIChatMessageComm({
        sessionId: message.sessionId,
        currentEmployee,
        message: messageBody,
        predictType: AI_CHAT_PREDICT.FILE_SUMMARY
      });
    }
    // 增加智能体id
    messageBody.agentId = currentAIRobot?.agentId || "";
    console.log(`tj:>>sendLLMMessage>>>messageBody.agentId>`, messageBody);
    imService.sendLLMMessage(messageId, messageBody).then((result: any) => {
      updateQuestionHistory({ id: result?.id, data: [messageBody.content] });
      if (result?.id === messageId) {
        if (mountedRef.current) {
          setStatus(MessageStatus.SUCCESS);
        }
        if (result?.body) {
          result.body.status = MessageStatus.SUCCESS;
        }
        updateSessionMessageMid({
          sessionId: selectedSession.sessionId,
          sendResult: result
        });
        clearMessage();
      } else {
        if (mountedRef.current) {
          setStatus(MessageStatus.SENDING);
        }
        updateTempMessageStatus({
          status: MessageStatus.FAILED,
          id: messageBody.id,
          sessionId: selectedSession.sessionId
        });
      }
    });
  }, [
    message,
    questionHistory,
    canSearchUser,
    currentEmployee,
    updateQuestionHistory,
    updateSessionMessageMid,
    selectedSession.sessionId,
    clearMessage,
    updateTempMessageStatus,
    currentAIRobot?.agentId
  ]);

  // 失败聚合消息重发
  const sendfailedMessage = useCallback(async () => {
    let msg: any = message;
    const imService = ImService.getInstance();
    deleteAttr(message);
    const messageBody = omit(cloneDeep(message), [
      "status",
      "taskId",
      "task",
      "mid",
      "beforeMid",
      "sessionId",
      "groupId",
      "statusType",
      "plusList",
      "_id",
      "_rev",
      "belong",
      "datetime",
      "mid",
      "localSendTimestamp",
      "readNum",
      "readUids"
    ]) as any;
    const sessionId = selectedSession.sessionId;
    if (sessionId) {
      await imService.sendChatMessage(sessionId, msg.id, { ...messageBody }).then(async (data) => {
        if (!data) return;
        msg.plusList?.map((user: any, index: any) => {
          if (data.body.id === user.uuid) {
            user.messageId = data.mid;
            user.statusType = MessageStatus.SUCCESS;
          }
        });
        const result = await imService.updateMergedMessage(message.sessionId, message.mid, {
          ...message,
          plusList: msg.plusList as any
        });
        if (result && data && mountedRef.current) {
          clearMessage();
          updateSessionMessageMid({
            sessionId: message.sessionId,
            sendResult: {
              body: { ...message, plusList: msg.plusList }
            }
          });
          setStatus(MessageStatus.SUCCESS);
        }
      });
    }
  }, [message, selectedSession, deleteAttr, updateSessionMessageMid, clearMessage]);

  useEffect(() => {
    if (beginSend && (status === MessageStatus.SENDING || status === MessageStatus.UPLOADING)) {
      setStatus(MessageStatus.SENDING);
      isAIChatNoticeSessionId(selectedSession?.sessionId).then((res) => {
        if (res) {
          sendLLMMessage();
        } else {
          sendMessage();
        }
      });
      return;
    } else if (!beginSend) {
      if (message.task && message.task.state === FileStatus.FAILED) {
        setStatus(MessageStatus.FAILED);
      } else if (message.status === MessageStatus.INIT) {
        setStatus(MessageStatus.SENDING);
      }
      return;
    } else if (typeof message.mid === "undefined") {
      setStatus(MessageStatus.FAILED);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [beginSend, selectedSession?.sessionId]);

  const sendMessageAgain = debounce(() => {
    let msg: any = message;
    Prompt({
      icon: <IconFont type="iconic_failure" style={{ color: "#F96137" }} />,
      title: t("send-message-again"),
      cancelText: t("cancelText"),
      onOk: async () => {
        setStatus(MessageStatus.SENDING);
        await sleep(500);
        if (message.task && message.task.state !== FileStatus.COMPLETED) {
          // 如果没有上传完文件 先处理上传文件
          if (connectState.state === ConnectState.READY) {
            message.task.cancel().then(() => {
              message.task.start().then(() => {
                if (mountedRef.current) setStatus(MessageStatus.UPLOADING);
              });
            });
          } else {
            if (mountedRef.current) setStatus(MessageStatus.FAILED);
          }
        } else if (msg.plusList) {
          sendfailedMessage();
        } else {
          sendMessage();
        }
      },
      okText: t("determine")
    });
  }, 200);
  const listener = useCallback(
    (param: { uploadStatus: FileStatus }) => {
      if (param.uploadStatus === FileStatus.UPLOADING) {
        setStatus(MessageStatus.SENDING);
        if (connectState.state !== ConnectState.READY) {
          sleep(500).then(() => {
            setStatus(MessageStatus.FAILED);
          });
        }
      } else if (param.uploadStatus === FileStatus.CANCELED) {
        setStatus(MessageStatus.CANCELED);
      }
    },
    [connectState.state]
  );

  const isIntent = useMemo(() => {
    return isLLMAI && showIntentTail(message);
  }, [message, isLLMAI]);

  useEffect(() => {
    EventBus.on(`chat:file-upload-status:${message.id}`, listener);
    return () => {
      EventBus.off(`chat:file-upload-status:${message.id}`, listener);
    };
  }, [listener, message.id]);

  useEffect(() => {
    if (message.taskId && message.task && messageUploadState) {
      const task = message.task;
      switch (task.state) {
        case FileStatus.FAILED:
          setStatus(MessageStatus.FAILED);
          break;
        case FileStatus.CANCELED:
          setStatus(MessageStatus.CANCELED);
          break;
        case FileStatus.UPLOADING:
          setStatus(MessageStatus.SENDING);
          break;
      }
    }
    if (
      message?.quillImage?.length &&
      message?.statusType !== MessageStatus.SUCCESS &&
      tempSessionMessageMap[message.sessionId]?.length
    ) {
      tempSessionMessageMap[message.sessionId].find((item: any) => {
        if (item?.status && item.id === message.id) {
          message.status = item.status;
        }
      });
      if (message?.status === MessageStatus.FAILED) {
        setStatus(MessageStatus.FAILED);
      }
    }
  }, [message, messageUploadState, status, tempSessionMessageMap]);

  if (sendType === MessageSendType.OTHER) {
    if (message.type === ChatMessageType.VOICE && !(message as any).isPlayOrTurn) {
      return <div className="voice-check-tag" />;
    }
    return null;
  }

  const getContent = () => {
    if (sendType === MessageSendType.OWNER || sendType === MessageSendType.SELF) {
      if (message.statusType === MessageStatus.SENDING) {
        return (
          <Spin
            spinning={message.statusType === MessageStatus.SENDING}
            size="small"
            delay={5}
            indicator={antIcon}
            style={{
              width: "14px",
              height: "14px",
              lineHeight: "14px",
              marginTop: "-14px"
            }}
          />
        );
      } else if (status === MessageStatus.CANCELED) {
        return null;
      } else if (
        (status === MessageStatus.FAILED && message.statusType !== MessageStatus.SUCCESS) ||
        message?.status === MessageStatus.FAILED
      ) {
        return (
          <Tooltip title={t("send-again")}>
            <IconFont
              type="iconic_failure"
              className="failure_icon"
              style={{ color: "#F5222D" }}
              onClick={sendMessageAgain}
              clstag="pageclick|keycount|Xtbg_Msg|SendAgain"
            />
          </Tooltip>
        );
      } else if (sendType === MessageSendType.OWNER) {
        if ([SessionType.SINGLE, SessionType.SECRET_SINGLE].includes(sessionType)) return getMessageState();
        // else if (SessionType.GROUP && (selectedSession.info as any).msgDongRead === 1) {
        //   return getGroupMessageReadState();
        // }
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  return (

    <div
      className={
        // 群组、是自己发送的文件，icon位置调整
        ([ChatMessageType.FILE, ChatMessageType.EGOV_FILE].includes(message.type) || isIntent) &&
        isEqualEmployee(message.sender, currentEmployee)
          ? "group-file message-control-container"
          : "message-control-container"
      }
      style={{
        display: getContent() ? 'block' : 'none'
  }}
    >
      {getContent()}
    </div>
  );
};

function mapStateToProps({ chat }: { chat: ChatState }) {
  const {
    selectedSession,
    messageUploadStateMap,
    currentEmployee,
    connectState,
    sessionMessageMap,
    tempSessionMessageMap,
    questionHistory,
    administrator,
    sub_administrator,
    quickReplys,
    currentAIRobot
  } = chat;
  return {
    selectedSession,
    messageUploadStateMap,
    currentEmployee,
    connectState,
    sessionMessageMap,
    tempSessionMessageMap,
    questionHistory,
    administrator,
    sub_administrator,
    quickReplys,
    currentAIRobot
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    clearTempMessage(data: { msgId: string }) {
      dispatch({ type: "chat/clearTempMessage", payload: data });
    },
    clearMessageUploadState(data: { msgId: string }) {
      dispatch({ type: "chat/clearMessageUploadState", payload: data });
    },
    updateSessionMessageMid(data: { sendResult: any; sessionId: String }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    },
    updateTempMessageStatus(data: { status: MessageStatus; sessionId: String; id: string }) {
      dispatch({ type: "chat/updateTempMessageStatus", payload: data });
    },
    updateQuestionHistory(data: any) {
      dispatch({ type: "chat/updateQuestionHistory", payload: data });
    },
    deleteSessionMessages(data: any) {
      dispatch({ type: "chat/deleteSessionMessages", payload: data });
    },
    async updateMessageUploadState(data: { msgId: string; progress: number }) {
      await dispatch({ type: "chat/updateMessageUploadState", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageControl);
